<template>
	<div class="homePage">
    <div class="bid-list bid-list__list layout shadow">
<div class="bid-list__header">
  <h2 class="h2 bid-list__h2">中标公示</h2>
  
</div>

<div class="bid-list__content bg-white">

  <ul class="bid-list__content-header  gongs clearfix bg-fafafa tab_bidtype">
  
  <li><div>招标名称</div></li><li><div>标书日期</div></li>
	<li><div>公示日期</div></li>
  <li><div><span class="desc-state">中标单位</span></div></li>

  </ul>
  
  
   <div class="bid-list__content-content">
      <ul class="bid-list__content-ul  gongs clearfix " v-for="(item) in tableData" :key="item.comment_id">
     
      <li><div><p>{{item.article.title}}</p></div></li>
     <li><div><p>{{item.article.bdate}}</p></div></li>
      <li><div><p>{{formatDate(item.create_time)}}</p></div></li>
   <li><div><p>{{item.user.company	}}</p></div></li>
      
      </ul>
      
     
       
   </div>
   
   

</div>


</div>
<el-pagination :pager-count="5" class="pagination" background layout="pager" 
   :total="total" :current-page="page" :page-size="page_size" @current-change="setPage"></el-pagination>
			
	</div>
</template>

<script>
	export default {
		name: "gongshi",
		components: {},
		data() {
			return {
				tableData: [],
				page:1,//当前页
				page_size:15,
				total:0,//全部条数
			};
		},
		created() {
			
		},
		mounted() {
			this.getreqCommentList()
		},
		methods: {
         formatDate(dateString) {
            return dateString.split(' ')[0]; // 直接分割空格前的部分
         },
			setPage(e){
				this.page = e;
				this.getreqCommentList();
			},
			
			async getreqCommentList(){
				let res = await this.req.reqCommentList({
					page:this.page,
				});
				console.log(res)
				
				if (res.status == 200) {
					this.tableData = res.data.list.data;
					this.total = res.data.list.total;
					this.page = res.data.list.current_page;
					this.page_size = res.data.list.per_page;
				} else {
					this.$message.error(res.message);
				}
			},
			
		},
	};
</script>

<style lang="less" scoped>
	.pagination{
				margin: 40px auto 0px;
				display: flex;
				align-items: center;
				justify-content: center;
			}
	
</style>
